export class PopupFeatures {
  constructor(private width: number, private height: number, private hideNavigationButtons: boolean = true) {}

  get(): string {
    const width = 'width=' + this.width;
    const height = 'height=' + this.height;
    const location = this.hideNavigationButtons ? 'location=no' : '';
    return width + ',' + height + ',' + location;
  }
}
